/**
 * Parses the connection url to extract the relevant parts
 * @internal
 */
export function parseUrlParts(url) {
    // wac connection: https://server/ws/v2.8/repositories/datasourceInstanceId/PW_WSG/Project/projectId
    // ds connection:  https://server/ws/v2.8/repositories/datasourceInstanceId
    // server url can contain additional parts separated by '/'
    // finds relevant parts of connection Url by working with constants in the url we control like the term repositories and PW_WSG schema
    const containsWorkArea = url.toLocaleLowerCase().includes('pw_wsg/project');
    const connectionUrlParts = url.split('/');
    const projectId = containsWorkArea
        ? connectionUrlParts[connectionUrlParts.length - 1]
        : '';
    const datasourceIdPosition = containsWorkArea
        ? connectionUrlParts.length - 4
        : connectionUrlParts.length - 1;
    const datasourceId = connectionUrlParts[datasourceIdPosition];
    const repositoriesStringPosition = connectionUrlParts.findIndex((item) => {
        return item.toLocaleLowerCase() == 'repositories';
    });
    if (repositoriesStringPosition < 1) {
        throw new Error('Invalid connection url');
    }
    const version = connectionUrlParts[repositoriesStringPosition - 1];
    let serverUrl = connectionUrlParts
        .slice(0, repositoriesStringPosition)
        .join('/');
    serverUrl += '/';
    const schemaNamePosition = connectionUrlParts.findIndex((item) => {
        return item.toLocaleLowerCase() == 'pw_wsg';
    });
    const connectionUrl = containsWorkArea
        ? connectionUrlParts.slice(0, schemaNamePosition).join('/')
        : url;
    return {
        connectionUrl,
        datasourceId,
        projectId,
        serverUrl,
        version
    };
}
